// External libraries
import styled from '@emotion/styled';

// Internal modules
import { StyledText } from '../Common';
import {
  FONT_SIZE_REGULAR,
  FONT_SIZE_SMALL,
  FONT_WEIGHT_NORMAL_PP,
  HIGH_CONTRAST_TEXT_COLOR,
  LABEL_COLOR,
  NON_INPUT_BORDER_COLOR,
  TEXT_COLOR,
} from '@/styles';

const ApplePayGuestDisclaimerMessage = styled.p`
  color: ${TEXT_COLOR};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 19px 0;
  text-align: center;
`;

const DisclaimerMessageContainer = styled.p`
  color: ${TEXT_COLOR};
  font-size: 13px;
  font-weight: 400;
  line-height: 1.6;
  margin-bottom: 23.5px;
`;

const BaslButtonContainer = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  padding: 20px 0;

  @media (min-width: 376px) {
    padding: 12px 0 20px;
  }
`;

const BaslHaveAnAccountText = styled.p`
  color: ${HIGH_CONTRAST_TEXT_COLOR};
  font-size: ${FONT_SIZE_REGULAR};
  font-weight: ${FONT_WEIGHT_NORMAL_PP};
  line-height: 24px;
  margin-right: 32px;
`;

const OrDivider = styled.div`
  border-top: 1px solid ${NON_INPUT_BORDER_COLOR};
  margin-bottom: 0.2em;
  text-align: center;
`;

const OrText = styled(StyledText)`
  background-color: white;
  color: ${LABEL_COLOR};
  bottom: 11px;
  display: inline;
  font-size: ${FONT_SIZE_SMALL};
  font-weight: ${FONT_WEIGHT_NORMAL_PP};
  padding: 0 8px;
  position: relative;
`;

const MainContentAreaComponent = styled.main`
  display: flex;
  flex-direction: column;
`;

export {
  ApplePayGuestDisclaimerMessage,
  BaslButtonContainer,
  BaslHaveAnAccountText,
  MainContentAreaComponent,
  DisclaimerMessageContainer,
  OrDivider,
  OrText,
};
